<template>
  <div>
    <NavItem></NavItem>
    <el-container
      class="elContainer"
      :style="{ left: menuIsCollapse ? '64px' : '200px' }"
      style="height: 100%"
      :class="{ 'elContainer-t': menuIsCollapse }"
    >
      <app-header></app-header>
      <div class="mainRoute">
        <div class="contentRoute">
          <div class="mainBackground">
            <transition name="fade-transform" mode="out-in">
              <keep-alive :include="cachedViewsName">
                <!--<keep-alive>-->
                <router-view></router-view>
              </keep-alive>
            </transition>
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import NavItem from "./navItem";
import AppHeader from "./appHeader";
import { getCookie, Token } from "@/utils/cookie";
export default {
  name: "index",
  components: {
    AppHeader,
    NavItem,
  },
  created() {
    console.log("?????aaaa???? Token",Token)
    let currentUserSave = JSON.parse(localStorage.getItem("currentUserObj"));
    this.$store.commit('SET_CURRENT_USER', currentUserSave)

    let _this = this;
    window.addEventListener("visibilitychange", (e)=>{
        console.log("visibilitychange ????");

      // if (document.hidden == false) {
      //   console.log("切换浏览器Tab");
      //   let lastLoginUser = localStorage.getItem("lastLoginUser");
      //   let currentUser =  currentUserSave.currentUser;
      //   //let currentUser =  _this.$store.state.user.currentUser.userName;
      //   console.log("最后一次登录用户", lastLoginUser);
      //   console.log("当前窗口缓存用户", currentUser);
      //   //当最后一次登录用户与当前窗口缓存用户不一致时刷新页面，保证本系统所有窗口用户信息与最后一次登录用户一致
      //   //if (lastLoginUser && currentUser && lastLoginUser != currentUser) {
      //   if (lastLoginUser != currentUser) {
      //     console.log(
      //       "当前窗口缓存用户与最后一次登录用户不一致刷新页面同步用户信息"
      //     );

      //     window.location.reload();
      //   }
      // }

    });

  },
  computed: {
    cachedViewsName() {
      console.log(
        "cachedViewsName",
        this.$store.state.tagsView.cachedViewsName
      );
      return this.$store.state.tagsView.cachedViewsName;
    },
    menuIsCollapse() {
      console.log("menuIsCollapse", this.$store.getters.menuIsCollapse);
      return this.$store.getters.menuIsCollapse;
    },
  },
  methods: {

  },
};
</script>

<style scoped>
.elContainer {
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  left: 200px;
  top: 0;
  width: calc(100% - 200px);
}
.elContainer-t {
  width: calc(100% - 64px);
}
.mainRoute {
  width: 100%;

  background-color: #f3f3f3;
  margin-top: 90px;
}

.contentRoute {
  padding: 15px;
}

.mainBackground {
  padding: 15px 20px;
  background-color: #fff;
  box-shadow: 0 1px 1px 0px rgba(0, 34, 77, 0.06);
  min-width: 993px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue